module.exports = __webpack_public_path__ + "img/shiba-loading.ca217741.gif";